<div class="cpcontent">
    <div id="formdiv" style="max-width:250px;margin: 0 auto;margin-top:150px">
        <h2 id="loginid">Sign in</h2>
        <br />
        <input id="username" type="text" class="form-control" [(ngModel)]="username" />
        <br>
        <input id="password" type="password" class="form-control" [(ngModel)]="password" />
        <br>
        <button id="submit" class="btn btn-primary" (click)="login()">Login</button><br><br>

        <br>
        <div class="link" (click)="resetPassword()">Reset password</div>
        {{message}}
    </div>

</div>
<!-- Modal -------------------------------------------------------------------------------------->
<div *ngIf="showModal" class="cpmodal">
    <div class="cpmodal-content" style="max-width:600px">
        <h5>Reset Password</h5>
        Please, enter and submit your email to reset the password. You will receive an email with a link where you can put in your new password.
        <br><br>
        <input class="form-control" type="text" [(ngModel)]="resetemail" /><br><br>
        <button id="submit" class="btn btn-primary" (click)="submitreset()">Submit</button>
        <button class="btn btn-secondary" style="float:right" (click)="showModal = false">Close Modal</button>

    </div>
</div>